exports.countryDefinition = {
  country: 'Bahamas',
  code: 'BS',
  schema: {
    company: { label: 'Company' },
    address: { label: 'P.O. Box' },
    city: { label: 'Town', width: 0.5 }
  },
  viewFormat: [['company'], ['address'], ['city']],
  formFormat: [['company'], ['address'], ['city']],
  requiredFormFields: [{ field: 'address' }, { field: 'city' }]
};
